<template>
  <div>
    <top-bar />
    <div class="row">
      <side-bar class="side-bar" />
      <div class="content">
        <router-view />
        <fhs-footer class="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import NavBar from "@/components/common/NavBar";
import Footer from "@/components/common/Footer";

export default {
  components: {
    "top-bar": TopBar,
    "side-bar": NavBar,
    "fhs-footer": Footer
  }
};
</script>

<style scoped>
.content {
  width: 94%;
  min-height: 90vh;
  display: grid;
}

.side-bar {
  width: 6%;
}

.footer {
  margin-top: 10px;
  align-self: end;
}

@media (max-width: 1500px) {
  .content {
    width: 93%;
  }

  .side-bar {
    width: 7%;
  }
}

@media (max-width: 1300px) {
  .content {
    width: 93%;
  }

  .side-bar {
    width: 7%;
  }
}

@media (max-width: 1100px) {
  .content {
    width: 100%;
    padding: 0 0 10vh;
  }

  .side-bar {
    width: 100%;
  }
}
</style>
